import {
    Checkbox as MuiCheckbox,
    CheckboxProps as MuiCheckboxProps,
    FormControlLabel,
    FormControlLabelProps,
    FormGroup,
} from '@mui/material';
import { FunctionComponent } from 'react';

type CheckboxProps = {
    label: string;
    value?: boolean;
    name?: string;
    disabled?: boolean;
    sx?: FormControlLabelProps['sx'];
    onChange: MuiCheckboxProps['onChange'];
    defaultChecked?: boolean;
};

export const Checkbox: FunctionComponent<CheckboxProps> = ({
    value,
    label,
    name,
    disabled = false,
    sx,
    onChange,
    defaultChecked,
}) => {
    return (
        <FormGroup>
            <FormControlLabel
                sx={sx}
                control={
                    <MuiCheckbox
                        onChange={onChange}
                        name={name}
                        checked={value}
                        defaultChecked={defaultChecked}
                    />
                }
                label={label}
                disabled={disabled}
            />
        </FormGroup>
    );
};
